// Wait until the DOM is fully loaded to execute any code
document.addEventListener('DOMContentLoaded', function() {
  // Ensure the modal is hidden initially when the page loads
  document.getElementById('emi-modal').style.display = 'none'; // Hide the modal initially
  document.body.style.overflow = ''; // Ensure page scroll is enabled

  // Open the modal when the "View Plans" button is clicked
  document.querySelectorAll('.emi-view-plans-btn').forEach(button => {
    button.addEventListener('click', function() {
      document.getElementById('emi-modal').style.display = 'flex'; // Show the modal
      document.body.style.overflow = 'hidden'; // Disable page scroll
    });
  });

  // Close the modal when the close button is clicked
  document.querySelector('.emi-modal-close-btn').addEventListener('click', function() {
    document.getElementById('emi-modal').style.display = 'none'; // Hide the modal
    document.body.style.overflow = ''; // Enable page scroll again
  });

  // Close the modal if the overlay is clicked
  document.querySelector('.emi-modal-overlay').addEventListener('click', function(event) {
    if (event.target === document.querySelector('.emi-modal-overlay')) {
      document.getElementById('emi-modal').style.display = 'none'; // Hide the modal
      document.body.style.overflow = ''; // Enable page scroll again
    }
  });
});